import { render } from "./Servers.vue?vue&type=template&id=189792f0"
import script from "./Servers.vue?vue&type=script&lang=js"
export * from "./Servers.vue?vue&type=script&lang=js"

import "./Servers.vue?vue&type=style&index=0&id=189792f0&lang=css"
script.render = render

export default script